export const Reading = {
  en: "Continue Reading",
  id: "Selengkapnya",
  ch: "继续阅读",
};
